import Vue from 'vue'
import LegacyApi from '@/lib/api/legacy'
import store from '@/store'
import { platform } from '@/plugins/native-app/capacitor'
import appVersion from '@/lib/app-version'

const slack = {
  install(vm) {
    vm.prototype.$slack = {
      sendMessage: async (message, channels = ['sml-activity']) => {
        try {
          let app = store.getters['app/getApp']
          let appIs = store.getters['app/appIs']

          const premiumPrefix = appIs.payingUser || appIs.platinum ? ' :first_place_medal:' : ''

          const userUrl =
            app.user && app.user.userRef
              ? `<${process.env.VUE_APP_LEGACY_API_BASE_ADMIN_URL}/admin/user.php?ref=${app.user.userRef}|${app.user.firstName} ${app.user.lastName}>${premiumPrefix}`
              : 'Guest'

          const userPrefix = appIs.suspicious ? ' *SUSPICIOUS USER* - ' : ''

          if (appIs.suspicious) {
            channels.push('fraud')
          }

          const browserSize = document.getElementById('app').getAttribute('data-breakpoint')

          let messagePrefix = `v${appVersion} ${platform} ${browserSize} -${userPrefix} ${userUrl} - `

          let combinedMessage = messagePrefix + message

          // If local then override channel to bot-test, but indicate what channels it would have gone to
          if (process.env.VUE_APP_ENVIRONMENT !== 'production') {
            combinedMessage = `${combinedMessage} [${channels.join(',')}]`

            // Alex returns, bot-test channel no longer exists
            channels = ['sml-activity-dev']
          }

          const notifyApi = new LegacyApi({
            message: combinedMessage,
            channel: channels[0]
          })

          await notifyApi.post('slack.add')
        } catch (error) {
          console.error('Error sending slack message', error)
        }
      }
    }
  }
}

Vue.use(slack)
